export default __webpack_public_path__ + "static/media/13.53b83991.jpg";